import PageComponent from "../components/page/PageComponent.vue";
import SectionSheet from "../components/section_sheet/SectionSheet.vue";
import IdVerificationReport from "@/layouts/pdf_reporting/id_liveness_verification/IdVerificationReport.vue";
import OcrLivenessVerificationReport from "@/layouts/pdf_reporting/ocr_liveness_verification/OcrLivenessVerificationReport.vue";

export default {
  name: "AlternativeVerificationReport",
  components: {
    IdVerificationReport,
    OcrLivenessVerificationReport,
    PageComponent,
    SectionSheet,
  },
  props: {
    verification_data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    sheet_elements: {
      type: String,
      default: ".sheet",
      required: false,
    },
  },
  data() {
    return {
      report_id: `ALT-LIV-${Date.now().toString().slice(-8)}`,
      generated_date: new Date().toLocaleDateString("en-GB").replace(/\//g, "-"),
      customer_image: null,
    };
  },
  computed: {
    /**
    * Returns verification data, mapped for backward compatibility if needed
    */
    mapped_verification_data() {
      if (this.verification_data && this.verification_data.TrackingNumber) {
        return {
          idv_data: this.verification_data || {},
          ocr_data: {},
          liveness_data: {},
          facial_comparison_data: {},
          selfie_image: null,
          comparison_image: this.verification_data?.LivenessImage || null,
        };
      }
      if (!this.verification_data.TrackingNumber && this.verification_data.LivenessResult) {
        return {
          idv_data: this.verification_data || {},
          ocr_data: {},
          liveness_data: {},
          facial_comparison_data: {},
          selfie_image: null,
          comparison_image: this.verification_data?.LivenessImage || null,
        };
      }
      return this.verification_data;
    },
    /**
     * Check if ID verification data is available
     * @returns {Boolean}
     */
    has_idv_data() {
      return (
        this.mapped_verification_data &&
        this.mapped_verification_data.idv_data &&
        Object.keys(this.mapped_verification_data.idv_data).length > 0
      );
    },
    /**
     * Check if OCR liveness verification data is available
     * @returns {Boolean}
     */
    has_ocr_data() {
      return (
        this.mapped_verification_data &&
        this.mapped_verification_data.ocr_data &&
        Object.keys(this.mapped_verification_data.ocr_data).length > 0 &&
        this.mapped_verification_data.liveness_data &&
        Object.keys(this.mapped_verification_data.liveness_data).length > 0 &&
        this.mapped_verification_data.facial_comparison_data &&
        Object.keys(this.mapped_verification_data.facial_comparison_data).length > 0
      );
    },
    /**
     * Extract OCR liveness data
     * @returns {Object|null}
     */
    ocr_liveness_data() {
      if (this.has_ocr_data) {
        return {
          ocr_data: this.mapped_verification_data.ocr_data,
          liveness_data: this.mapped_verification_data.liveness_data,
          facial_comparison_data: this.mapped_verification_data.facial_comparison_data,
          selfie_image: this.mapped_verification_data.selfie_image || null,
          comparison_image: this.mapped_verification_data.comparison_image || null
        };
      }
      return null;
    },
    /**
     * Extract ID verification data
     * @returns {Object|null}
     */
    idv_data() {
      if (this.has_idv_data) {
        this.customer_image = this.mapped_verification_data.comparison_image || null;
        var result_data = this.mapped_verification_data.idv_data?.result;
        if (result_data) {
          return result_data;
        }
        else {
          return this.mapped_verification_data.idv_data;
        }
      }
      return null;
    },
  },
};
